import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription, of } from 'rxjs';

import { InputContentDataType } from 'client/models';
import { createOptionGrouper } from 'common/helper';
import { AnswerTypeComponent } from '../answer-type.component';
import { FormStore } from './../../common/form.store';

@Component({
    selector: 'answer-select',
    templateUrl: './answer-select.component.html',
    standalone: false
})
export class AnswerSelectComponent extends AnswerTypeComponent implements OnInit, OnDestroy {

  private subs = new Subscription();
  // Live grouping - the base swaps optionsObs when a webform rule returns its options, so a
  // one-shot ngOnInit grouping rendered rule-populated dropdowns empty.
  public optionGroupsFor = createOptionGrouper<InputContentDataType>((o) => o.heading);

  ngOnInit() {
    super.ngOnInit();
    this.optionsObs = of(this.inputContent.inputContentDatas);

    const sub = FormStore.reset$.subscribe(() => {
      setTimeout(() => {
        (this.formControlObj as FormControl).patchValue('');
      });
    });
    this.subs.add(sub);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
